var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSheep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 188,
    viewBox: "0 0 183 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.59 42.25C144.59 46.65 141.02 50.22 136.62 50.22C132.22 50.22 128.65 46.65 128.65 42.25C128.65 37.85 132.22 34.29 136.62 34.29C141.02 34.29 144.59 37.85 144.59 42.25Z",
    fill: "url(#paint0_linear_12888_35034)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5201 42.25C53.5201 46.65 49.9501 50.22 45.5501 50.22C41.1501 50.22 37.5801 46.65 37.5801 42.25C37.5801 37.85 41.1501 34.29 45.5501 34.29C49.9501 34.29 53.5201 37.85 53.5201 42.25Z",
    fill: "url(#paint1_linear_12888_35034)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.08 187.98C88.32 187.98 86.06 185.73 86.06 182.96V119.67L56.15 106.61C54.58 106.04 53.39 104.72 52.98 103.09C52.59 101.47 53.03 99.75 54.17 98.51L86.06 68.45V5.16C86.06 2.39 88.31 0.140015 91.08 0.140015C93.85 0.140015 96.11 2.39 96.11 5.16V70.4C96.11 71.66 95.64 72.86 94.79 73.79L66.65 99.75L92.81 111.45C94.8 112.17 96.12 114.06 96.12 116.16V182.96C96.12 185.73 93.87 187.98 91.09 187.98",
    fill: "url(#paint2_linear_12888_35034)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.14 5.05002C182.11 3.69002 181.55 2.46001 180.64 1.57001C180.57 1.50001 180.47 1.47 180.39 1.41C179.99 1.06 179.56 0.73002 179.06 0.52002C178.47 0.27002 177.82 0.130005 177.12 0.130005C176.42 0.130005 175.78 0.27002 175.18 0.52002C174.69 0.73002 174.26 1.06 173.85 1.41C173.78 1.47 173.68 1.51001 173.61 1.57001C172.7 2.46001 172.15 3.69002 172.12 5.05002H172.1V142.44C172.1 162.02 156.18 177.94 136.6 177.94H45.52C25.95 177.94 10.03 162.02 10.03 142.44V5.05002H10.01C9.99 3.69002 9.43 2.46001 8.52 1.57001C8.46 1.51001 8.36 1.48001 8.3 1.42001C7.89 1.06001 7.46 0.73002 6.96 0.52002C6.36 0.27002 5.7 0.130005 5.02 0.130005C4.34 0.130005 3.68 0.27002 3.08 0.52002C2.59 0.73002 2.16 1.06 1.76 1.41C1.68 1.47 1.59 1.51001 1.51 1.57001C0.600002 2.46001 0.0500043 3.69002 0.0200043 5.05002H0V142.44C0 167.59 20.39 187.98 45.54 187.98H136.62C161.77 187.98 182.15 167.59 182.15 142.44V5.05002H182.14Z",
    fill: "url(#paint3_linear_12888_35034)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.84 126.77C155.79 124.89 152.48 124.89 150.46 126.79C134.6 141.6 113.51 149.75 91.0698 149.75C68.6298 149.75 47.5598 141.6 31.6998 126.79C29.6898 124.9 26.3698 124.89 24.3198 126.77C23.3298 127.69 22.7798 128.91 22.7798 130.23C22.7798 131.54 23.3098 132.77 24.3098 133.7C42.1398 150.34 65.8598 159.51 91.0698 159.51C116.28 159.51 140.02 150.34 157.86 133.7C158.85 132.77 159.39 131.54 159.38 130.23C159.38 128.92 158.83 127.69 157.83 126.77",
    fill: "url(#paint4_linear_12888_35034)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12888_35034",
    x1: 128.65,
    y1: 42.26,
    x2: 144.59,
    y2: 42.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12888_35034",
    x1: 37.5801,
    y1: -299.9,
    x2: 53.5201,
    y2: -299.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12888_35034",
    x1: 52.84,
    y1: 94.06,
    x2: 96.1,
    y2: 94.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12888_35034",
    x1: 0.01,
    y1: 94.06,
    x2: 182.16,
    y2: 94.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12888_35034",
    x1: 22.7798,
    y1: 142.44,
    x2: 159.39,
    y2: 142.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57C4C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheep);
export default __webpack_public_path__ + "static/media/sheep.5c1a7b705a159f27339cc6b40f976672.svg";
export { ForwardRef as ReactComponent };